import { Mapper } from '../../../mappers';
import {
  InviteTrialUserForm,
  TrialUser,
  TrialUserStatus,
} from '../../../models';
import { TrialUser as FerretTrialUser } from '../models';

export class ReadTrialUserMapper extends Mapper<
FerretTrialUser ,
   TrialUser
> {
  from(source: FerretTrialUser ): TrialUser {
    return {
      uid: source.Uid,
      firstName: source.FirstName ?? '',
      lastName: source.LastName ?? '',
      email: source.Email ?? '',
      status: source.Status === 'Accepted' ? TrialUserStatus.Accepted : TrialUserStatus.Pending,
      dateSent: source.DateSent ?? '',
    };
  }
}

export class InviteTrialUserFerretMapper extends Mapper<
  InviteTrialUserForm,
  FerretTrialUser
> {
  from(source: InviteTrialUserForm): FerretTrialUser {
    return {
      Uid: source.userId,
      FirstName: source.firstName,
      LastName: source.lastName,
      Email: source.email,
    };
  }
}


export class InviteToTrialUserMapper extends Mapper<
  InviteTrialUserForm,
  TrialUser
> {
  from(source: InviteTrialUserForm): TrialUser {
    return {
      uid: source.userId,
      firstName: source.firstName,
      lastName: source.lastName,
      email: source.email,
      status: TrialUserStatus.Pending,
      dateSent: new Date().toISOString(),
    };
  }
}